import personal from "./personal";

let form: any[any] = [];

form['personal'] = personal;

export default form;
